import type {ReactNode} from 'react'
import {cn} from './cn'

/** Detail values share a scale; list/calendar density remains owned by their list components. */
export function DetailMetadataItem({label, value, className}: {label: ReactNode; value: ReactNode; className?: string}) {
    return <div className={cn('flex min-w-0 flex-col items-center text-center', className)}>
        <div className="max-w-full text-sm font-medium leading-5 text-gray-500 dark:text-gray-400">{label}</div>
        <div className="mt-1 min-w-0 w-full max-w-full break-words text-base font-semibold leading-6 text-gray-900 dark:text-gray-100">{value}</div>
    </div>
}

export function DetailMetadataGrid({count, children, className, maxColumns = 4}: {count: number; children: ReactNode; className?: string; maxColumns?: 2 | 4}) {
    if (!count) return null
    return <div className={cn('grid items-start gap-x-4 gap-y-4', count === 1 ? 'grid-cols-1' : 'grid-cols-2',
        maxColumns === 4 && count === 3 && 'sm:grid-cols-3', maxColumns === 4 && count >= 4 && 'sm:grid-cols-4', className)}>{children}</div>
}

/** Keep the identity group centered for one person, and every row left aligned for a list. */
export function DetailPeople({people}: {people: {key: string; avatar: ReactNode; name: ReactNode}[]}) {
    if (!people.length) return null
    return <ul className={cn('flex min-w-0 flex-col gap-2', people.length === 1 ? 'items-center' : 'items-start')}>
        {people.map(person => <li key={person.key} className="flex min-w-0 max-w-full items-center gap-2 text-left text-base font-semibold leading-6 text-gray-900 dark:text-gray-100">
            {person.avatar}<div className="min-w-0 break-words">{person.name}</div>
        </li>)}
    </ul>
}
